import $ from 'jquery'

export function initContractsPage () {
  const body = document.body

  const isContractsController = body.classList.contains('contracts-controller')
  const isIndex = body.classList.contains('index-action')
  const isShow = body.classList.contains('show-action')

  if (!isContractsController || (!isIndex && !isShow)) return

  // Click supplier row -> load modal content via AJAX
  $('#contract-view').on('click', '.supplier-index-listing', function () {
    const supplierId = this.dataset.supplierId
    const contractId = this.dataset.contractId

    $('#contracts-supplier-modal .content').empty()
    $.ajax({ url: `/contracts/${contractId}/suppliers/${supplierId}` })
  })

  // Change contract -> load that contract via AJAX
  $('#select-contract').on('change', function () {
    const contractId = $(this).val()
    if (!contractId) return

    $.ajax({ url: `/contracts/${contractId}` })
  })
}
